import { axiosInstance } from "../../config/axios";
import { AxiosError } from "axios";
import { useMutation } from "react-query";
import { BaseResponse } from "../_types";

export type GetChangeRequestListRequest = {
  roleLevel?: number;
  makerUserId?:number;
  startDate?: string;
  endDate?: string;
  status?:string;
}

export type IChangeRequest = {
  roleLevel?: number;
  makerUserId?:number;
  startDate?: string;
  endDate?: string;
  status?:string
}

export type GetChangeRequestListResponse = BaseResponse<Array<IChangeRequest>> & { data2?: number };

async function getChangeRequestList(data: GetChangeRequestListRequest): Promise<GetChangeRequestListResponse> {
  try {
    return (await axiosInstance.post("/ChangeRequest/ListPending", data))
      .data;
  } catch (ex) {
    throw ((ex as AxiosError).response?.data as any).error;
  }
}

export function useGetChangeRequestList() {
  return useMutation<GetChangeRequestListResponse, Error, GetChangeRequestListRequest>((variables) =>
    getChangeRequestList(variables)
  );
}
